<template>
	<b-container fluid class="rb-series">
		<b-row class="rb-series-hero" :style="seriesHeroStyle">
			<b-col md="12" class="my-5 mx-3">
				<transition name="fade">
					<b-row v-if="series">
						<img :src="series.getLogoUrl()" alt="" class="rb-series-logo">
					</b-row>
				</transition>

				<rb-loader v-if="!series" center></rb-loader>
			</b-col>
		</b-row>

		<transition name="fade">
			<b-row v-if="loaded">
				<b-col xl="8" offset-xl="2" lg="10" offset-lg="1" class="rb-series-body py-5 px-4">
					<div v-for="cat in categories" :key="cat.Id">
						<h2>{{ cat.Name }}</h2>

						<rb-horizontal-scroll class="playlist my-4" :speed="360">
							<rb-video-thumbnail
								v-for="v in cat.Videos" :key="v.Id"
								:video="v"
								active
								small
							/>
						</rb-horizontal-scroll>
					</div>
				</b-col>
			</b-row>
		</transition>
	</b-container>
</template>

<script>
	import RbHorizontalScroll from '../components/RbHorizontalScroll';
	import RbVideoThumbnail from '../components/RbVideoThumbnail';
	import RbLoader from '../components/RbLoader';

	export default {
		name: 'Series',
		components: {RbLoader, RbVideoThumbnail, RbHorizontalScroll},
		metaInfo() {
			return {
				title: this.series ? this.series.Name : 'Carregando...'
			}
		},
		data: () => ({
			loaded: false,
			series: null,
			categories: []
		}),
		watch: {
			'$route': async function () {
				this.loadData();
			}
		},
		async mounted() {
			this.loadData();
		},
		methods: {
			async loadData() {
				if (!this.series || this.series.Id !== this.$route.params.seriesId) {
					this.series = await this.$oldApi.Series.get(this.$route.params.seriesId);

					this.categories = await this.$oldApi.Category.listBySeries(this.$route.params.seriesId);

					this.loaded = true;
				}
			}
		},
		computed: {
			seriesHeroStyle(){
				return this.series ? {
					backgroundImage: `url("${this.series.getHeroUrl()}")`
				} : {};
			}
		}
	}
</script>
<style lang="scss" scoped>
	.rb-series {
		background-color: rgba($dark, .6);
	}

	.rb-series-hero {
		height: 45vh;
		background-position: center left;
		background-size: cover;
		position: relative;
		transition: all .3s;

		&:before {
			content: '';
			background: linear-gradient(to bottom, rgba(0, 0, 0, .9) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, .5) 100%);
			opacity: .5;
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;

			transition: all .5s ease;
		}

		.rb-series-logo {
			max-height: 20vh;
			max-width: 30vw;
		}
	}

	.rb-series-body {
		.playlist {
			.rb-thumbnail {
				width: 350px;

				&.active {
					opacity: .7;
					&:hover {
						opacity: 1;
					}
				}
			}
		}
	}

	@include media-breakpoint-down(md) {
		.rb-series-hero {
			height: 30vh;

			.rb-series-logo {
				max-height: 20vh;
				max-width: 30vw;
			}
		}
	}
</style>